<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useOrganizerFeeDisplay } from '@/composables/useOrganizerFeeDisplay'

const { t } = useI18n()
const { formattedCreditRate, registrationFeeParams } = useOrganizerFeeDisplay()
</script>

<template>
  <section class="bg-white py-24">
    <div class="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center max-w-2xl mx-auto">
        <p class="text-emerald-600 font-semibold text-sm uppercase tracking-widest">
          {{ t('organizers_lp.pricing.label') }}
        </p>
        <h2 class="text-3xl md:text-4xl font-bold text-slate-900 mt-3">
          {{ t('organizers_lp.pricing.heading') }}
        </h2>
        <p class="text-slate-500 mt-4">
          {{ t('organizers_lp.pricing.subtext') }}
        </p>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-12">
        <!-- Per registration -->
        <div class="bg-slate-50 rounded-2xl p-8 border border-slate-200">
          <div class="w-10 h-10 text-emerald-500 mb-6">
            <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-full h-full">
              <circle cx="20" cy="20" r="14" stroke="currentColor" stroke-width="2.5" />
              <path d="M20 10v2M20 28v2M14 14l1.4 1.4M24.6 24.6l1.4 1.4M10 20h2M28 20h2M14 26l1.4-1.4M24.6 15.4l1.4-1.4" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
              <path d="M17 20a3 3 0 106 0 3 3 0 00-6 0z" fill="currentColor" fill-opacity="0.2" stroke="currentColor" stroke-width="2" />
            </svg>
          </div>
          <h3 class="text-lg font-bold text-slate-900">{{ t('organizers_lp.pricing.card_registration_title') }}</h3>
          <p class="text-3xl font-black text-emerald-600 mt-2">{{ t('organizers_lp.pricing.card_registration_rate', registrationFeeParams) }}</p>
          <p class="text-sm text-slate-500 mt-1">{{ t('organizers_lp.pricing.card_registration_caption') }}</p>
          <p class="text-slate-600 mt-4 leading-relaxed">{{ t('organizers_lp.pricing.card_registration_body', registrationFeeParams) }}</p>
        </div>

        <!-- Email credits -->
        <div class="bg-slate-50 rounded-2xl p-8 border border-slate-200">
          <div class="w-10 h-10 text-emerald-500 mb-6">
            <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-full h-full">
              <rect x="6" y="10" width="28" height="20" rx="3" stroke="currentColor" stroke-width="2.5" />
              <path d="M6 10l14 12L34 10" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
          <h3 class="text-lg font-bold text-slate-900">{{ t('organizers_lp.pricing.card_credits_title') }}</h3>
          <p class="text-3xl font-black text-emerald-600 mt-2">{{ t('organizers_lp.pricing.card_credits_rate', { rate: formattedCreditRate }) }}</p>
          <p class="text-sm text-slate-500 mt-1">{{ t('organizers_lp.pricing.card_credits_caption') }}</p>
          <p class="text-slate-600 mt-4 leading-relaxed">{{ t('organizers_lp.pricing.card_credits_body') }}</p>
        </div>
      </div>

      <p class="text-center text-slate-500 mt-8 font-medium">
        {{ t('organizers_lp.pricing.participant_note') }}
      </p>
    </div>
  </section>
</template>
